<template>
  <div class="feature-section">
    <div class="text-h5 text-md-h4 mb-6 mb-md-12">
      Помогайте другим пациентам выбрать лучшего врача
    </div>
    <v-row>
      <v-col
        cols="12"
        md="5"
      >
        <v-sheet
          height="100%"
          class="d-flex flex-column justify-space-between bg-ui-kit-bg-secondary rounded-xl px-6 pt-8"
        >
          <div class="mb-4 text-h6 text-sm-landing-h5">
            Оставляйте отзывы о врачах и клиниках после приёма
          </div>

          <LandingFeatureImage
            class="align-self-center"
            src="/images/features/patient/rate_published.png"
            sm-src-set="/images/features/patient/rate_published.png 1x,
                        /images/features/patient/rate_published_3x.png 3x"
            alt="Опубликованный отзыв"
            width="312"
            sm-width="312"
          />
        </v-sheet>
      </v-col>

      <v-col
        cols="12"
        md="7"
      >
        <v-sheet
          height="100%"
          class="d-flex flex-column justify-space-between bg-ui-kit-bg-secondary rounded-xl px-6 pt-8"
        >
          <div class="mb-4 text-h6 text-sm-landing-h5">
            Отслеживайте, скольким людям ваш опыт помог выбрать хороших специалистов
          </div>

          <LandingFeatureImage
            class="align-self-center"
            src="/images/features/patient/rate_hits.png"
            sm-src-set="/images/features/patient/rate_hits_mobile.png 1x"
            alt="Статистика просмотров отзыва"
            width="100%"
            sm-width="312"
          />
        </v-sheet>
      </v-col>
    </v-row>

    <div class="mt-6 mt-md-12 d-flex flex-column align-stretch align-sm-center">
      <LandingFeatureBtn
        target="_blank"
        text="Получить доступ к МедТочке"
        width="360"
        :href="mtUrl"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const locale = useAppLocale()

const mtUrl = computed(() => {
  const baseUrl = useRuntimeConfig().public.mtUrl

  if (locale.isRu) {
    return baseUrl
  }

  return `${baseUrl}/authorization/?preselected_country=${locale.currentCountry}`
})
</script>
